import { pxToRem } from '../../../../utils';
/** ChatItem styles specific for the compact density. */

export var chatItemStylesCompact = {
  root: function root(_ref) {
    var p = _ref.props;
    return Object.assign({}, (!p.attached || p.attached === 'top') && {
      paddingTop: pxToRem(8)
    }, {
      marginTop: pxToRem(-2),
      marginBottom: pxToRem(-2)
    });
  },
  gutter: function gutter(_ref2) {
    var v = _ref2.variables;
    return {
      marginTop: v.gutterMarginCompact,
      left: pxToRem(28)
    };
  },
  message: function message(_ref3) {
    var v = _ref3.variables;
    return {
      marginLeft: v.messageMarginCompact,
      marginRight: v.messageMarginEndCompact,
      width: "calc(100% - " + v.messageMarginCompact + " - " + v.messageMarginEndCompact + ")"
    };
  }
};